// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vueConfig from 'vue-config'
import VueResource from 'vue-resource'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import App from './App'
import langs from './langs'

Vue.config.productionTip = process.env.NODE_ENV === 'production'

if (process.env.NODE_ENV === 'production') {
  Raven
    .config(process.env.SENTRY_DSN, {
      environment: process.env.NODE_ENV
    })
    .addPlugin(RavenVue, Vue)
    .install()
}

Vue.use(vueConfig, {
  isProd: Vue.config.productionTip
})

Vue.use(VueResource)

Vue.http.options.root = process.env.API

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en',
  messages: langs
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js